import { TextBoxOption } from "../../sections/TextSection";
import { Field } from "./Field";
import "./styles/textBoxField.css";

export class TextBoxesField extends Field {
  private textBoxes: TextBoxOption[];
  private input: HTMLInputElement | null = null;
  private boxContainer: HTMLDivElement | null = null;

  constructor(name: string, value: TextBoxOption[], onChange: (newValue: any) => void) {
    super(name, value, onChange);
    this.textBoxes = Array.isArray(value) ? value : [];
  }

  private createTextBoxControl(option: TextBoxOption): HTMLElement {
    const box = document.createElement('div');
    box.className = 'textbox-control';
    
    const labelText = document.createElement('span');
    labelText.textContent = option.label;
    labelText.title = option.label;
    labelText.style.textOverflow = 'ellipsis';
    labelText.style.overflow = 'hidden';
    labelText.style.width= '30px';
    
    const correctValueInput = document.createElement('input');
    correctValueInput.type = 'text';
    correctValueInput.title = 'Correct Value'
    correctValueInput.value = option.correctValue;
    correctValueInput.style.width= '40px';
    correctValueInput.onchange = (e) => {
      option.correctValue = (e.target as HTMLInputElement).value;
      this.onChange(this.textBoxes);
    };
    const optionalValueInput = document.createElement('input');
    optionalValueInput.type = 'text';
    optionalValueInput.title = 'Optional Values'
    optionalValueInput.value = (option.optionalValue)?option.optionalValue:'';
    optionalValueInput.style.width= '40px';
    optionalValueInput.onchange = (e) => {
      option.optionalValue = (e.target as HTMLInputElement).value;
      this.onChange(this.textBoxes);
    };
    const minOptionalValuesInput = document.createElement('input');
    minOptionalValuesInput.type = 'text';
    minOptionalValuesInput.title = 'minimum input Values'
    minOptionalValuesInput.value = (option.minimumOptionalValue)?String(option.minimumOptionalValue):'0';
    minOptionalValuesInput.style.width= '30px';
    minOptionalValuesInput.onchange = (e) => {
      var val = (e.target as HTMLInputElement).value;
      if(val == '0'){
        option.minimumOptionalValue = 0;
        this.onChange(this.textBoxes);
      }
      else if(Number(val)){
        option.minimumOptionalValue = Number(val);
        this.onChange(this.textBoxes);
      }
      else{
        alert("Please enter number only")
        minOptionalValuesInput.value = String(option.minimumOptionalValue);
      }
    };

    const maxWidthValueInput = document.createElement('input');
    maxWidthValueInput.type = 'text';
    maxWidthValueInput.style.width='30px';
    maxWidthValueInput.title = 'maximum width percentage'
    maxWidthValueInput.value = (option.labelMaxWidth)?option.labelMaxWidth:'';
    maxWidthValueInput.onchange = (e) => {
      option.labelMaxWidth = (e.target as HTMLInputElement).value;
      this.onChange(this.textBoxes);
    };

    const visibilityToggle = document.createElement('span');
    visibilityToggle.className = `textbox-visibility ${option.showLabel ? '' : 'hidden'}`;
    visibilityToggle.innerHTML = '👁️';
    visibilityToggle.onclick = () => {
      option.showLabel = !option.showLabel;
      visibilityToggle.className = `textbox-visibility ${option.showLabel ? '' : 'hidden'}`;
      this.onChange(this.textBoxes);
    };

    const deleteBtn = document.createElement('span');
    deleteBtn.className = 'textbox-delete';
    deleteBtn.textContent = '×';
    deleteBtn.onclick = () => this.removeTextBox(option.label);

    box.appendChild(labelText);
    box.appendChild(correctValueInput);
    box.appendChild(optionalValueInput);
    box.appendChild(minOptionalValuesInput);
    box.appendChild(visibilityToggle);
    box.appendChild(maxWidthValueInput);
    box.appendChild(deleteBtn);
    
    return box;
  }

  private removeTextBox(label: string): void {
    this.textBoxes = this.textBoxes.filter(box => box.label !== label);
    this.value = this.textBoxes;
    this.updateBoxDisplay();
    this.onChange(this.textBoxes);
  }

  private updateBoxDisplay(): void {
    if (this.boxContainer) {
      this.boxContainer.innerHTML = '';
      this.textBoxes.forEach(box => {
        this.boxContainer?.appendChild(this.createTextBoxControl(box));
      });
    }
  }

  public render(): HTMLElement {
    const container = this.createContainer();

    this.boxContainer = document.createElement('div');
    this.boxContainer.className = 'textbox-container';
    
    this.input = document.createElement('input');
    this.input.type = 'text';
    this.input.className = 'textbox-input';
    this.input.placeholder = 'Type label and press Enter';

    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && this.input?.value.trim()) {
        e.preventDefault();
        const newLabel = this.input.value.trim();
        if (!this.textBoxes.some(box => box.label === newLabel)) {
          const newBox: TextBoxOption = {
            label: newLabel,
            correctValue: '',
            showLabel: true
          };
          this.textBoxes.push(newBox);
          this.value = this.textBoxes;
          this.updateBoxDisplay();
          this.onChange(this.textBoxes);
        }
        this.input.value = '';
      }
    });

    container.appendChild(this.boxContainer);
    container.appendChild(this.input);

    this.updateBoxDisplay();
    (container as any)['fieldObj'] = this;

    return container;
  }
}
